<template>
  <div class="custom-loader">
    <div class="loader-content">
      <div class="logo-container">
        <img
          src="/assets/logo/i.png"
          class="loader-logo"
          alt="HamrahZar Logo"
        />
      </div>
      <div class="loader-text">
        <h3 class="brand-name">HAMRAHZAR</h3>
        <p class="loading-text">در حال بارگذاری...</p>
      </div>
      <div class="custom-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },

  mounted() {},
};
</script>
  
  
  
  <style scoped>
/* Custom Loader Styles */
.custom-loader {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #141518 0%, #1e1f25 50%, #141518 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Vazirmatn', sans-serif;
}

.loader-content {
  text-align: center;
  color: #ffffff;
}

.logo-container {
  margin-bottom: 2rem;
  animation: logoFloat 3s ease-in-out infinite;
}

.loader-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 0 20px rgba(239, 177, 0, 0.3));
}

.loader-text {
  margin-bottom: 2rem;
}

.brand-name {
  background: -webkit-linear-gradient(45deg, #efb100, #7d3b02);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 0.5rem 0;
  letter-spacing: 2px;
  animation: textGlow 2s ease-in-out infinite alternate;
}

.loading-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin: 0;
  font-family: 'Vazirmatn FD', sans-serif;
}

.custom-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.spinner-ring {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--bs-gold-light);
  animation: ringPulse 1.4s ease-in-out infinite both;
}

.spinner-ring:nth-child(1) {
  animation-delay: -0.32s;
}

.spinner-ring:nth-child(2) {
  animation-delay: -0.16s;
}

.spinner-ring:nth-child(3) {
  animation-delay: 0s;
}

/* Animations */
@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes textGlow {
  0% {
    text-shadow: 0 0 5px rgba(239, 177, 0, 0.3);
  }
  100% {
    text-shadow: 0 0 20px rgba(239, 177, 0, 0.6), 0 0 30px rgba(239, 177, 0, 0.4);
  }
}

@keyframes ringPulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .loader-logo {
    width: 60px;
    height: 60px;
  }
  
  .brand-name {
    font-size: 1.5rem;
    letter-spacing: 1px;
  }
  
  .loading-text {
    font-size: 0.9rem;
  }
  
  .spinner-ring {
    width: 10px;
    height: 10px;
  }
}

@media (max-width: 480px) {
  .loader-logo {
    width: 50px;
    height: 50px;
  }
  
  .brand-name {
    font-size: 1.2rem;
  }
  
  .loading-text {
    font-size: 0.8rem;
  }
}

/* RTL Support */
[dir="rtl"] .loader-content {
  direction: rtl;
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .logo-container,
  .brand-name,
  .spinner-ring {
    animation: none;
  }
  
  .spinner-ring {
    opacity: 0.7;
  }
}
</style>